var _style, _path, _path2, _line, _line2, _line3, _line4, _path3, _g, _g2, _g3, _polygon, _g4, _path4, _path5, _polygon2, _path6, _path7, _path8, _path9, _ellipse, _polygon3, _polygon4, _path0, _polyline, _polygon5, _polygon6, _g5, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _path1, _polygon14, _path10, _path11, _path12, _path13, _polygon15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSatellite = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Sattelite",
  x: "0px",
  y: "0px",
  viewBox: "0 0 132 119.2",
  style: {
    enableBackground: "new 0 0 132 119.2"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.webst0{fill:#D39232;}\r\n\t.webst1{fill:#502A23;}\r\n\t.webst2{fill:#0D73B8;stroke:#0C4C76;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.webst3{fill:url(#SVGIDW_1_);}\r\n\t.webst4{fill:#7A411B;}\r\n\t.webst5{fill:url(#SVGIDW_2_);}\r\n\t.webst6{fill:url(#SVGIDW_3_);}\r\n\t.webst7{fill:url(#SVGIDW_4_);}\r\n\t.webst8{fill:url(#SVGIDW_5_);}\r\n\t.webst9{fill:url(#SVGIDW_6_);}\r\n\t.webst10{fill:url(#SVGIDW_7_);}\r\n\t.webst11{fill:url(#SVGIDW_8_);}\r\n\t.webst12{fill:url(#SVGIDW_9_);}\r\n\t.webst13{fill:url(#SVGIDW_10_);}\r\n\t.webst14{fill:url(#SVGIDW_11_);}\r\n\t.webst15{fill:url(#SVGIDW_12_);}\r\n\t.webst16{fill:url(#SVGIDW_13_);}\r\n\t.webst17{fill:url(#SVGIDW_14_);}\r\n\t.webst18{fill:url(#SVGIDW_15_);}\r\n\t.webst19{fill:url(#SVGIDW_16_);}\r\n\t.webst20{fill:url(#SVGIDW_17_);}\r\n\t.webst21{fill:url(#SVGIDW_18_);}\r\n\t.webst22{fill:url(#SVGIDW_19_);}\r\n\t.webst23{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.webst24{fill:#33363A;}\r\n\t.webst25{fill:#F58220;}\r\n\t.webst26{opacity:0.61;}\r\n\t.webst27{fill:none;stroke:#653413;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.webst28{fill:none;stroke:#653413;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.webst29{fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\r\n\t.webst30{fill:#142929;}\r\n\t.webst31{fill:none;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\r\n\t.webst32{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.webst33{fill:#8C6234;}\r\n\t.webst34{fill:#5F3317;}\r\n\t.webst35{fill:#552010;}\r\n\t.webst36{fill:#831F19;stroke:#754E4A;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.webst37{fill:#7F5A24;stroke:#532A14;stroke-miterlimit:10;}\r\n\t.webst38{fill:#4C2825;stroke:url(#SVGIDW_20_);stroke-miterlimit:10;}\r\n\t.webst39{fill:#4C2825;stroke:url(#SVGIDW_21_);stroke-miterlimit:10;}\r\n\t.webst40{fill:url(#SVGIDW_22_);}\r\n\t.webst41{fill:#26221E;}\r\n\t.webst42{fill:#656A76;}\r\n\t.webst43{fill:#423A32;}\r\n\t.webst44{fill:#DAAE2D;stroke:#FDFAD9;stroke-miterlimit:10;}\r\n\t.webst45{fill:#1C1110;}\r\n\t.webst46{fill:#938D96;}\r\n\t.webst47{fill:#0D73B8;}\r\n\t.webst48{fill:#EFD7BE;}\r\n\t.webst49{fill:url(#SVGIDW_23_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "webst0",
  d: "M48.9,56.8c0,0,1.2-2.8,3.2-4.4l-15.5-8c0,0-5.1,5.4-3.4,5.6L48.9,56.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "webst1",
  d: "M46.9,56.8c0,0,1.1-2.5,2.8-3.8l-13.6-7c0,0-4.5,4.8-3,4.9L46.9,56.8z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "webst23",
  x1: 59,
  y1: 57.7,
  x2: 61.1,
  y2: 62.3
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "webst23",
  x1: 74.7,
  y1: 25.7,
  x2: 94.7,
  y2: 69.3
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "webst23",
  x1: 85.2,
  y1: 44.2,
  x2: 86.8,
  y2: 47.5
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "webst23",
  x1: 96.5,
  y1: 38.2,
  x2: 98.1,
  y2: 41.7
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "webst24",
  d: "M44.3,69.3l0.7-0.4c0,0,0-1.8-1.1-2l-0.7,0.4l0,0.2l-0.5,0.3c0,0-0.4,0.1-0.2,0.5L13.6,85.5 c0,0-0.1,0.7,0.5,0.9L43,69.3c0,0,0.1,0.3,0.3,0.2l0.5-0.3L44.3,69.3z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "115.4,28 84.8,44.3 75.9,24.7 104.3,6.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "83.5,45 59,58 51.6,40.1 74.6,25.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "94.9,69.3 68.3,80.3 60.3,61.6 85.5,48.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "129.2,54.6 96.1,68.8 86.7,48 117.4,31.8  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "19.4,81.3 5.6,89.3 2.2,76.8 15.2,67.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "37.1,70.6 20,80.6 16.1,66.9 32.1,55.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "24.3,98.2 9.8,104.9 6.1,91.8 20,83.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst25",
  points: "43.5,89.1 25.1,97.8 20.8,83.3 38,73.2  "
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "webst26"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 76.4,
  y1: 25.5,
  x2: 105.3,
  y2: 7.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 76.8,
  y1: 26.3,
  x2: 105.7,
  y2: 8.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 77.2,
  y1: 27.2,
  x2: 106,
  y2: 9.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 77.5,
  y1: 27.9,
  x2: 106.4,
  y2: 10.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 77.9,
  y1: 28.7,
  x2: 106.9,
  y2: 11.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 78.2,
  y1: 29.4,
  x2: 107.3,
  y2: 12
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 78.6,
  y1: 30.3,
  x2: 107.8,
  y2: 12.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 79,
  y1: 31.1,
  x2: 108.4,
  y2: 13.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 108.7,
  y1: 14.5,
  x2: 79.3,
  y2: 31.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 79.7,
  y1: 32.7,
  x2: 109.2,
  y2: 15.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 80.1,
  y1: 33.6,
  x2: 109.7,
  y2: 16.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 80.5,
  y1: 34.3,
  x2: 110.1,
  y2: 17.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 81.3,
  y1: 36,
  x2: 111,
  y2: 19
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 81.6,
  y1: 36.8,
  x2: 111.5,
  y2: 19.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 82,
  y1: 37.7,
  x2: 111.9,
  y2: 20.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 82.4,
  y1: 38.5,
  x2: 112.5,
  y2: 21.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 82.7,
  y1: 39.3,
  x2: 112.9,
  y2: 22.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 83.1,
  y1: 40.1,
  x2: 113.3,
  y2: 23.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 83.5,
  y1: 40.9,
  x2: 113.8,
  y2: 24.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 84,
  y1: 41.7,
  x2: 114.3,
  y2: 25.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 84.3,
  y1: 42.7,
  x2: 114.7,
  y2: 26
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 84.6,
  y1: 43.4,
  x2: 115.2,
  y2: 27
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 85.1,
  y1: 44.4,
  x2: 115.7,
  y2: 28
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 76.1,
  y1: 24.7,
  x2: 85.1,
  y2: 44.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 104.7,
  y1: 6.9,
  x2: 76.1,
  y2: 24.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 115.7,
  y1: 28,
  x2: 104.7,
  y2: 6.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 77.1,
  y1: 24.1,
  x2: 86.3,
  y2: 43.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 78.5,
  y1: 23.2,
  x2: 87.5,
  y2: 43
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 79.5,
  y1: 22.6,
  x2: 88.8,
  y2: 42.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 80.7,
  y1: 21.8,
  x2: 90.1,
  y2: 41.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 82,
  y1: 21,
  x2: 91.2,
  y2: 40.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 84.5,
  y1: 19.5,
  x2: 94,
  y2: 39.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 85.7,
  y1: 18.7,
  x2: 95.3,
  y2: 38.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 86.9,
  y1: 18,
  x2: 96.8,
  y2: 38.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 88.3,
  y1: 17.1,
  x2: 98.2,
  y2: 37.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 89.6,
  y1: 16.3,
  x2: 99.5,
  y2: 36.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 90.9,
  y1: 15.5,
  x2: 101,
  y2: 35.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 92.2,
  y1: 14.7,
  x2: 102.4,
  y2: 35.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 93.5,
  y1: 13.8,
  x2: 103.8,
  y2: 34.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 94.9,
  y1: 13,
  x2: 105.3,
  y2: 33.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 97.6,
  y1: 11.3,
  x2: 108.1,
  y2: 31.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 99.1,
  y1: 10.3,
  x2: 109.7,
  y2: 31.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 100.4,
  y1: 9.5,
  x2: 111.2,
  y2: 30.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 102,
  y1: 8.6,
  x2: 112.6,
  y2: 29.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 103.5,
  y1: 7.6,
  x2: 114,
  y2: 28.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 116.3,
  y1: 32.6,
  x2: 128.1,
  y2: 55.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 114.8,
  y1: 33.4,
  x2: 126.4,
  y2: 56
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 113.3,
  y1: 34.2,
  x2: 124.7,
  y2: 56.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 111.7,
  y1: 35,
  x2: 123.1,
  y2: 57.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 110.3,
  y1: 35.8,
  x2: 121.6,
  y2: 58.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 108.7,
  y1: 36.6,
  x2: 119.8,
  y2: 58.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 107.3,
  y1: 37.5,
  x2: 118.3,
  y2: 59.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 105.8,
  y1: 38.1,
  x2: 116.8,
  y2: 60.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 104.3,
  y1: 39,
  x2: 115.1,
  y2: 60.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 102.9,
  y1: 39.7,
  x2: 113.6,
  y2: 61.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 101.5,
  y1: 40.4,
  x2: 112.1,
  y2: 62.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 100,
  y1: 41.2,
  x2: 110.6,
  y2: 62.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 98.7,
  y1: 41.9,
  x2: 108.9,
  y2: 63.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 97.4,
  y1: 42.6,
  x2: 107.6,
  y2: 64
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 95.9,
  y1: 43.4,
  x2: 106.1,
  y2: 64.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 94.8,
  y1: 43.9,
  x2: 104.8,
  y2: 65.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 93.3,
  y1: 44.7,
  x2: 103.1,
  y2: 65.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 91.9,
  y1: 45.4,
  x2: 101.9,
  y2: 66.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 90.5,
  y1: 46.2,
  x2: 100.3,
  y2: 67.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 89.1,
  y1: 46.9,
  x2: 99.1,
  y2: 67.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 88,
  y1: 47.5,
  x2: 97.6,
  y2: 68.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 118.2,
  y1: 32.8,
  x2: 87.1,
  y2: 48.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 118.7,
  y1: 33.9,
  x2: 87.5,
  y2: 49.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 119,
  y1: 34.8,
  x2: 87.9,
  y2: 50.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 119.7,
  y1: 35.6,
  x2: 88.3,
  y2: 51.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 120.1,
  y1: 36.6,
  x2: 88.7,
  y2: 52.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 120.6,
  y1: 37.5,
  x2: 89.1,
  y2: 52.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 121.1,
  y1: 38.5,
  x2: 89.5,
  y2: 53.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 121.6,
  y1: 39.4,
  x2: 89.8,
  y2: 54.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 122.1,
  y1: 40.5,
  x2: 90.3,
  y2: 55.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 122.6,
  y1: 41.3,
  x2: 90.7,
  y2: 56.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 123,
  y1: 42.3,
  x2: 91,
  y2: 57.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 123.7,
  y1: 43.4,
  x2: 91.6,
  y2: 58.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 124.1,
  y1: 44.2,
  x2: 91.9,
  y2: 59.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 124.6,
  y1: 45.1,
  x2: 92.3,
  y2: 59.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 125.1,
  y1: 46.2,
  x2: 92.7,
  y2: 61
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 125.5,
  y1: 47,
  x2: 93.2,
  y2: 61.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 126.1,
  y1: 48,
  x2: 93.5,
  y2: 62.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 126.6,
  y1: 48.9,
  x2: 93.9,
  y2: 63.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 127.1,
  y1: 49.9,
  x2: 94.3,
  y2: 64.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 127.6,
  y1: 50.9,
  x2: 94.7,
  y2: 65.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 128,
  y1: 51.9,
  x2: 95.1,
  y2: 66.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 128.6,
  y1: 52.8,
  x2: 95.7,
  y2: 67
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 129.1,
  y1: 53.9,
  x2: 95.9,
  y2: 67.9
})), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 129.5,
  y1: 54.7,
  x2: 96.1,
  y2: 68.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 86.7,
  y1: 48,
  x2: 96.1,
  y2: 68.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 117.7,
  y1: 31.9,
  x2: 86.7,
  y2: 48
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 129.5,
  y1: 54.7,
  x2: 117.7,
  y2: 31.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 55.3,
  y1: 48.9,
  x2: 79.1,
  y2: 35.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 83.6,
  y1: 44.9,
  x2: 74.6,
  y2: 25.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 51.6,
  y1: 40.1,
  x2: 74.6,
  y2: 25.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 59.1,
  y1: 58.1,
  x2: 51.7,
  y2: 40.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 83.6,
  y1: 44.9,
  x2: 59.1,
  y2: 58.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 52.4,
  y1: 39.6,
  x2: 60.1,
  y2: 57.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 53.4,
  y1: 38.9,
  x2: 61,
  y2: 57
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 54.4,
  y1: 38.3,
  x2: 62,
  y2: 56.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 55.4,
  y1: 37.7,
  x2: 63.1,
  y2: 55.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 57.4,
  y1: 36.4,
  x2: 65.2,
  y2: 54.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 58.4,
  y1: 35.8,
  x2: 66.3,
  y2: 54.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 59.5,
  y1: 35.1,
  x2: 67.4,
  y2: 53.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 60.4,
  y1: 34.5,
  x2: 68.6,
  y2: 53
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 61.6,
  y1: 33.9,
  x2: 69.7,
  y2: 52.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 62.5,
  y1: 33.1,
  x2: 70.7,
  y2: 51.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 63.6,
  y1: 32.5,
  x2: 71.8,
  y2: 51.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 64.6,
  y1: 31.9,
  x2: 73,
  y2: 50.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 65.7,
  y1: 31.2,
  x2: 74,
  y2: 50.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 66.8,
  y1: 30.5,
  x2: 75.3,
  y2: 49.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 69.1,
  y1: 29.1,
  x2: 77.6,
  y2: 48
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 70.3,
  y1: 28.3,
  x2: 78.9,
  y2: 47.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 71.4,
  y1: 27.6,
  x2: 80.1,
  y2: 46.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 72.4,
  y1: 27,
  x2: 81.3,
  y2: 46.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 73.6,
  y1: 26.2,
  x2: 82.6,
  y2: 45.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 52,
  y1: 40.8,
  x2: 75,
  y2: 26.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 52.3,
  y1: 41.5,
  x2: 75.4,
  y2: 27.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 52.5,
  y1: 42.1,
  x2: 75.6,
  y2: 28
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 52.9,
  y1: 42.9,
  x2: 76.1,
  y2: 28.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 53.2,
  y1: 43.6,
  x2: 76.5,
  y2: 29.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 53.5,
  y1: 44.4,
  x2: 76.8,
  y2: 30.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 53.8,
  y1: 45.2,
  x2: 77.2,
  y2: 31.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 54.1,
  y1: 45.9,
  x2: 77.6,
  y2: 31.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 54.5,
  y1: 46.8,
  x2: 77.9,
  y2: 32.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 54.7,
  y1: 47.5,
  x2: 78.4,
  y2: 33.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 55,
  y1: 48.2,
  x2: 78.7,
  y2: 34.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 56,
  y1: 50.4,
  x2: 79.8,
  y2: 36.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 56.3,
  y1: 51.2,
  x2: 80.2,
  y2: 37.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 56.6,
  y1: 52,
  x2: 80.6,
  y2: 38.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 56.9,
  y1: 52.7,
  x2: 81,
  y2: 39.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 57.2,
  y1: 53.5,
  x2: 81.4,
  y2: 40.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 57.6,
  y1: 54.3,
  x2: 81.7,
  y2: 40.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 57.9,
  y1: 55.1,
  x2: 82.1,
  y2: 41.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 58.2,
  y1: 55.9,
  x2: 82.6,
  y2: 42.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 58.5,
  y1: 56.6,
  x2: 82.9,
  y2: 43.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 58.8,
  y1: 57.3,
  x2: 83.3,
  y2: 44.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 85.3,
  y1: 48.6,
  x2: 94.8,
  y2: 69.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 84.1,
  y1: 49.2,
  x2: 93.6,
  y2: 69.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 85.3,
  y1: 48.6,
  x2: 60.4,
  y2: 61.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 68.4,
  y1: 80.7,
  x2: 60.4,
  y2: 61.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 94.8,
  y1: 69.4,
  x2: 68.4,
  y2: 80.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 82.9,
  y1: 49.9,
  x2: 92.3,
  y2: 70.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 81.6,
  y1: 50.5,
  x2: 91,
  y2: 71.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 80.4,
  y1: 51.2,
  x2: 89.7,
  y2: 71.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 79.2,
  y1: 51.8,
  x2: 88.4,
  y2: 72.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 76.9,
  y1: 53,
  x2: 85.9,
  y2: 73.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 75.6,
  y1: 53.7,
  x2: 84.7,
  y2: 73.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 74.4,
  y1: 54.3,
  x2: 83.3,
  y2: 74.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 73.4,
  y1: 54.9,
  x2: 82.1,
  y2: 74.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 72.3,
  y1: 55.5,
  x2: 81,
  y2: 75.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 71,
  y1: 56.1,
  x2: 79.8,
  y2: 75.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 70,
  y1: 56.6,
  x2: 78.5,
  y2: 76.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 69,
  y1: 57.3,
  x2: 77.3,
  y2: 76.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 67.8,
  y1: 57.8,
  x2: 76.2,
  y2: 77.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 66.8,
  y1: 58.4,
  x2: 75,
  y2: 77.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 64.7,
  y1: 59.5,
  x2: 72.7,
  y2: 78.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 63.6,
  y1: 60,
  x2: 71.5,
  y2: 79.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 62.5,
  y1: 60.6,
  x2: 70.4,
  y2: 79.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 61.5,
  y1: 61.1,
  x2: 69.4,
  y2: 80.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 68.1,
  y1: 79.9,
  x2: 94.4,
  y2: 68.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 94,
  y1: 67.6,
  x2: 67.9,
  y2: 79.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 67.4,
  y1: 78.3,
  x2: 93.6,
  y2: 66.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 93.2,
  y1: 65.9,
  x2: 67.2,
  y2: 77.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 66.7,
  y1: 76.6,
  x2: 92.8,
  y2: 65
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 92.4,
  y1: 64.1,
  x2: 66.4,
  y2: 75.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 66.1,
  y1: 75.1,
  x2: 92,
  y2: 63.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 91.4,
  y1: 62.4,
  x2: 65.7,
  y2: 74.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 91.1,
  y1: 61.4,
  x2: 65.5,
  y2: 73.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 90.8,
  y1: 60.6,
  x2: 65,
  y2: 72.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 64.7,
  y1: 71.7,
  x2: 90.4,
  y2: 59.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 64,
  y1: 70.1,
  x2: 89.6,
  y2: 57.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 89.1,
  y1: 57.2,
  x2: 63.7,
  y2: 69.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 63.4,
  y1: 68.6,
  x2: 88.8,
  y2: 56.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 88.4,
  y1: 55.5,
  x2: 63.2,
  y2: 67.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 62.7,
  y1: 67.1,
  x2: 87.9,
  y2: 54.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 87.6,
  y1: 53.6,
  x2: 62.3,
  y2: 66.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 62,
  y1: 65.4,
  x2: 87.3,
  y2: 52.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 86.9,
  y1: 52,
  x2: 61.7,
  y2: 64.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 61.4,
  y1: 63.9,
  x2: 86.4,
  y2: 51.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 86.1,
  y1: 50.2,
  x2: 61.1,
  y2: 63.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst27",
  x1: 60.7,
  y1: 62.3,
  x2: 85.7,
  y2: 49.4
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M23,90.7c7.1-3.7,10.7-5.6,17.8-9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M25.4,80.9c1.8,6,2.7,9,4.5,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M33.1,76.4c2,6.2,3,9.3,5.1,15.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M18.2,74.5c6.7-4.3,10-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M20.1,64.4c1.7,5.6,2.6,8.4,4.3,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M27.4,59.3c1.9,5.8,2.9,8.7,4.8,14.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.3,67.8c6.5-4.6,9.7-6.8,16.2-11.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.4,68.3c6.5-4.5,9.8-6.8,16.3-11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.6,68.9c6.5-4.5,9.7-6.7,16.2-11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.7,69.4c6.5-4.5,9.7-6.7,16.2-11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.9,70c6.5-4.4,9.8-6.7,16.3-11.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.1,70.5c6.5-4.4,9.8-6.6,16.3-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.2,71.1c6.6-4.4,9.8-6.6,16.4-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.4,71.6c6.6-4.4,9.9-6.6,16.5-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M34,61.3c-6.6,4.4-9.9,6.5-16.5,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.7,72.8c6.6-4.3,9.9-6.5,16.5-10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.9,73.4c6.6-4.3,9.9-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.1,73.9c6.7-4.3,10-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.4,75.1c6.7-4.3,10-6.4,16.7-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.6,75.6c6.7-4.2,10-6.4,16.7-10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.8,76.3c6.7-4.3,10.1-6.4,16.8-10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.9,76.8c6.7-4.2,10.1-6.3,16.9-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.1,77.4c6.7-4.2,10.1-6.3,16.9-10.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.2,77.9c6.8-4.2,10.2-6.2,16.9-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.4,78.5c6.8-4.1,10.2-6.2,17-10.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.7,79c6.8-4.1,10.2-6.2,16.9-10.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.8,79.7c6.8-4.2,10.2-6.2,17-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.9,80.2C26.8,76.2,30.2,74.1,37,70"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.1,80.9c6.9-4.1,10.3-6.1,17.1-10.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.1,67.2c1.6,5.5,2.4,8.2,4,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M32.2,55.9c-6.4,4.5-9.7,6.8-16.1,11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M37.3,70.7c-2-5.9-3-8.9-5.1-14.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.7,66.8c1.7,5.5,2.5,8.2,4.2,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.4,66.3c1.6,5.5,2.4,8.3,4.1,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18,65.9c1.7,5.5,2.5,8.3,4.2,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.7,65.4c1.7,5.5,2.5,8.3,4.2,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.4,64.9c1.7,5.5,2.5,8.3,4.2,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.8,63.9c1.7,5.6,2.6,8.4,4.3,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M21.5,63.4c1.7,5.6,2.6,8.3,4.3,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M22.2,63c1.8,5.6,2.7,8.4,4.5,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23,62.4c1.8,5.7,2.7,8.5,4.5,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23.7,61.9c1.8,5.7,2.7,8.5,4.5,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M24.4,61.4c1.8,5.7,2.8,8.5,4.6,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M25.2,60.9c1.9,5.7,2.8,8.6,4.7,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M25.9,60.3c1.9,5.7,2.8,8.6,4.7,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M26.7,59.8c1.9,5.8,2.8,8.6,4.7,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M28.2,58.7c1.9,5.8,2.8,8.6,4.7,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M29.1,58.1C31,64,32,66.9,33.9,72.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M29.8,57.6c2,5.8,3,8.8,5,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M30.7,57c1.9,5.9,2.9,8.8,4.9,14.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M31.5,56.4c1.9,5.9,2.9,8.8,4.8,14.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M37.4,73.9c2.2,6.4,3.2,9.5,5.4,15.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M36.5,74.4c2.1,6.3,3.2,9.5,5.3,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M35.7,74.9c2.1,6.3,3.1,9.5,5.2,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M34.8,75.4C36.9,81.6,38,84.8,40,91"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M34,75.9c2.1,6.2,3.1,9.3,5.2,15.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M33.1,76.4c2,6.2,3,9.3,5.1,15.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M32.4,77c2,6.1,3,9.2,5,15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M31.5,77.3c2,6.2,3,9.2,5,15.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M30.7,77.8c2,6.1,3,9.2,4.9,15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M29.9,78.3c1.9,6.1,2.9,9.2,4.8,15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M29.1,78.7c1.9,6.1,2.9,9.1,4.8,15.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M28.3,79.2c1.9,6,2.9,9.1,4.8,15.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M27.5,79.7c1.9,6,2.8,9.1,4.6,15.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M26.8,80.1c1.8,6,2.8,9,4.6,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M26,80.6c1.8,6,2.8,9,4.6,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M25.4,80.9c1.8,6,2.7,9,4.5,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M24.6,81.4c1.8,5.9,2.6,8.9,4.4,14.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23.8,81.9c1.8,5.9,2.7,8.8,4.5,14.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23,82.3c1.8,5.8,2.6,8.7,4.4,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M22.2,82.8c1.8,5.8,2.7,8.7,4.5,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M21.6,83.2c1.7,5.8,2.6,8.7,4.3,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M38.4,74.1C31.4,78,28,80,21.1,84"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M38.6,74.8c-7,3.9-10.4,5.8-17.4,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M38.8,75.4c-6.9,3.9-10.4,5.8-17.4,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M39.1,76c-7,3.9-10.5,5.8-17.5,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M39.3,76.7c-7,3.9-10.5,5.8-17.5,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M39.5,77.4c-7,3.8-10.5,5.7-17.6,9.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M39.7,78.1c-7,3.8-10.6,5.7-17.6,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M39.9,78.7c-7.1,3.8-10.6,5.6-17.7,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M40.2,79.4c-7.1,3.7-10.6,5.6-17.7,9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M40.4,80c-7.1,3.8-10.6,5.6-17.7,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M40.6,80.7c-7.1,3.7-10.7,5.6-17.8,9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M40.9,81.5C33.8,85.2,30.2,87,23,90.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M41.1,82c-7.1,3.7-10.7,5.5-17.9,9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M41.3,82.7c-7.2,3.6-10.8,5.5-17.9,9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M41.6,83.4c-7.2,3.6-10.8,5.4-18,9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M41.8,84c-7.2,3.6-10.8,5.4-18,9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M42,84.7c-7.2,3.6-10.9,5.3-18.1,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M42.2,85.4c-7.3,3.6-10.9,5.3-18.1,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M42.5,86c-7.3,3.5-10.9,5.3-18.2,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M42.7,86.7c-7.3,3.5-11,5.2-18.3,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M42.9,87.4c-7.3,3.5-10.9,5.2-18.2,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M43.2,88.1c-7.3,3.5-11,5.2-18.3,8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M43.4,88.8C36,92.2,32.4,93.9,25,97.3"
})), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M43.6,89.4c-7.4,3.5-11.1,5.2-18.5,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.9,83.5c1.7,5.8,2.5,8.7,4.2,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M38.1,73.4c-6.9,4-10.4,6-17.3,10"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M43.6,89.4c-2.2-6.4-3.3-9.6-5.5-15.9"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M5,75c1.4,5.1,2.1,7.6,3.5,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M11.5,70.4c1.5,5.3,2.3,7.9,3.8,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M4.2,83.5c5.3-3.4,8-5.2,13.3-8.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4,83.1c5.3-3.5,8-5.2,13.3-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.3,81.2c-1.6-5.4-2.4-8.1-4-13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.3,76.9c5.2-3.7,7.8-5.5,13-9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.6,89.4c-1.3-5-1.9-7.5-3.2-12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.3,81.2c-5.5,3.3-8.2,4.9-13.7,8.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.8,76.6c1.4,5,2,7.5,3.4,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.3,76.2c1.3,5,2,7.6,3.4,12.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.9,75.8c1.3,5,2,7.5,3.4,12.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.5,75.4c1.4,5.1,2,7.6,3.4,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.6,74.6c1.4,5.1,2.1,7.6,3.5,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.1,74.2c1.4,5.1,2.1,7.6,3.5,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.8,73.8c1.4,5.2,2.1,7.7,3.5,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.3,73.4c1.4,5.2,2.2,7.7,3.6,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.9,73c1.4,5.2,2.2,7.7,3.6,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M8.5,72.5c1.5,5.2,2.2,7.8,3.6,13"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.1,72.1c1.5,5.2,2.2,7.8,3.6,13"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.7,71.7c1.5,5.2,2.2,7.8,3.7,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M10.2,71.3c1.5,5.2,2.2,7.9,3.7,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M10.9,70.9c1.5,5.3,2.3,7.9,3.8,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M12.2,70c1.5,5.3,2.3,7.9,3.8,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M12.8,69.5c1.5,5.3,2.3,8,3.8,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M13.4,69.1c1.6,5.3,2.4,8,3.9,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M14.1,68.6c1.6,5.4,2.4,8,4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M14.7,68.2c1.6,5.4,2.4,8.1,4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.5,77.4c5.2-3.7,7.8-5.5,12.9-9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.6,77.9c5.2-3.6,7.8-5.4,13-9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.7,78.3c5.2-3.6,7.8-5.3,13-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M2.9,78.9c5.2-3.6,7.8-5.4,13.1-9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3,79.4c5.2-3.5,7.9-5.3,13.1-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.2,79.9c5.2-3.6,7.9-5.3,13.1-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.3,80.5c5.3-3.5,7.9-5.3,13.2-8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.4,81c5.3-3.5,7.9-5.3,13.2-8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.6,81.6c5.3-3.6,7.9-5.3,13.2-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.7,82.1c5.3-3.5,8-5.3,13.3-8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M3.8,82.5c5.3-3.5,8-5.2,13.3-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.2,84.1c5.4-3.4,8-5.1,13.4-8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.4,84.7c5.4-3.4,8-5.1,13.4-8.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.5,85.2c5.4-3.4,8-5.1,13.4-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.7,85.7c5.4-3.4,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.8,86.2c5.4-3.3,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M4.9,86.8c5.4-3.3,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.1,87.4c5.4-3.4,8.1-5,13.6-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.2,87.9c5.4-3.3,8.2-5,13.6-8.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.4,88.4c5.5-3.3,8.2-5,13.7-8.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M5.5,88.9c5.5-3.3,8.2-4.9,13.7-8.2"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M16,86.2c1.6,5.7,2.4,8.5,4,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M9.1,90.2c1.4,5.4,2.1,8.1,3.6,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst28",
  d: "M22.2,90.9c-5.7,3-8.6,4.5-14.3,7.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.1,83.8c1.7,5.8,2.6,8.7,4.3,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M19.4,84.2c1.7,5.7,2.6,8.6,4.3,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.1,83.8c-5.6,3.3-8.3,4.9-13.9,8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.7,105.2C8.3,99.9,7.6,97.3,6.2,92"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M24.3,98.3c-5.8,2.7-8.8,4.1-14.6,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18.7,84.6c1.7,5.8,2.5,8.6,4.2,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M18,85c1.7,5.7,2.5,8.6,4.2,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M17.3,85.4c1.7,5.7,2.5,8.5,4.2,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M16.7,85.8c1.6,5.7,2.5,8.5,4.1,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M15.4,86.6c1.6,5.6,2.4,8.5,4,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M14.7,87c1.6,5.6,2.4,8.4,4.1,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M14,87.4c1.6,5.6,2.4,8.4,4,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M13.4,87.7c1.6,5.5,2.3,8.3,3.9,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M12.8,88.1c1.6,5.5,2.3,8.3,3.9,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M12.1,88.5c1.6,5.5,2.3,8.2,3.9,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M11.5,88.8c1.5,5.5,2.3,8.3,3.8,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M10.9,89.2c1.5,5.4,2.2,8.2,3.7,13.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M10.3,89.5c1.5,5.5,2.2,8.2,3.7,13.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.7,89.9c1.5,5.4,2.2,8.1,3.7,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M8.5,90.6c1.4,5.4,2.1,8.1,3.6,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.9,90.9c1.4,5.3,2.1,8,3.5,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.3,91.3c1.4,5.3,2.1,8,3.5,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.8,91.6c1.4,5.3,2.1,8,3.4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.6,104.7c5.8-2.8,8.8-4.1,14.6-6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M24,97.1c-5.8,2.8-8.7,4.2-14.5,7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9.3,103.5c5.8-2.8,8.7-4.2,14.5-7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23.6,95.9c-5.8,2.8-8.7,4.2-14.5,7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M9,102.3c5.8-2.8,8.7-4.3,14.5-7.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M23.3,94.6c-5.8,2.8-8.6,4.3-14.4,7.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M8.7,101.3c5.8-2.9,8.6-4.3,14.4-7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M22.8,93.4c-5.7,2.9-8.6,4.3-14.3,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M22.7,92.7c-5.7,2.9-8.6,4.3-14.3,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M22.5,92.1c-5.7,2.9-8.6,4.4-14.3,7.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M8,98.9c5.7-2.9,8.6-4.4,14.3-7.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.8,97.8c5.7-3,8.5-4.5,14.2-7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M21.8,89.8c-5.7,3-8.5,4.5-14.1,7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.5,96.8c5.7-3,8.5-4.5,14.2-7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M21.5,88.6c-5.6,3.1-8.4,4.6-14.1,7.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M7.2,95.7c5.6-3.1,8.4-4.6,14.1-7.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M21.1,87.3C15.5,90.4,12.7,92,7,95.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.9,94.5c5.6-3.1,8.4-4.7,14.1-7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.8,86.2c-5.6,3.1-8.4,4.7-14,7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.6,93.5c5.6-3.1,8.4-4.7,13.9-7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M20.4,84.9c-5.6,3.2-8.4,4.8-14,8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst27",
  d: "M6.3,92.4c5.6-3.2,8.4-4.8,13.9-8.1"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 91.6,
  y1: 58.4,
  x2: 123.6,
  y2: 43.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 94.8,
  y1: 43.9,
  x2: 104.8,
  y2: 65.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 108.7,
  y1: 36.6,
  x2: 119.8,
  y2: 58.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 80.9,
  y1: 35.2,
  x2: 110.5,
  y2: 18.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 83.1,
  y1: 20.3,
  x2: 92.7,
  y2: 40.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 96.2,
  y1: 12.2,
  x2: 106.7,
  y2: 32.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 56.4,
  y1: 37.1,
  x2: 64.2,
  y2: 55.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 67.9,
  y1: 29.8,
  x2: 76.4,
  y2: 48.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 55.7,
  y1: 49.6,
  x2: 79.4,
  y2: 35.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 78,
  y1: 52.4,
  x2: 87.1,
  y2: 72.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 65.7,
  y1: 58.9,
  x2: 73.8,
  y2: 78.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst28",
  x1: 90,
  y1: 58.8,
  x2: 64.3,
  y2: 70.9
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 76.3,
  y1: 25.5,
  x2: 105,
  y2: 7.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 76.6,
  y1: 26.2,
  x2: 105.5,
  y2: 8.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 77,
  y1: 27.1,
  x2: 105.7,
  y2: 9.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 77.3,
  y1: 27.9,
  x2: 106.1,
  y2: 10.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 77.7,
  y1: 28.6,
  x2: 106.6,
  y2: 11.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 78,
  y1: 29.4,
  x2: 107.1,
  y2: 11.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 78.4,
  y1: 30.3,
  x2: 107.5,
  y2: 12.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 78.8,
  y1: 31,
  x2: 108.2,
  y2: 13.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 108.4,
  y1: 14.5,
  x2: 79.2,
  y2: 31.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 79.5,
  y1: 32.7,
  x2: 108.9,
  y2: 15.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 79.9,
  y1: 33.5,
  x2: 109.4,
  y2: 16.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 80.3,
  y1: 34.3,
  x2: 109.9,
  y2: 17.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 81.1,
  y1: 36,
  x2: 110.8,
  y2: 19
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 81.4,
  y1: 36.7,
  x2: 111.2,
  y2: 19.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 81.8,
  y1: 37.6,
  x2: 111.6,
  y2: 20.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 82.2,
  y1: 38.4,
  x2: 112.2,
  y2: 21.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 82.5,
  y1: 39.3,
  x2: 112.6,
  y2: 22.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 82.9,
  y1: 40,
  x2: 113.1,
  y2: 23.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 83.3,
  y1: 40.9,
  x2: 113.6,
  y2: 24.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 83.8,
  y1: 41.6,
  x2: 114,
  y2: 25.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 84.1,
  y1: 42.6,
  x2: 114.4,
  y2: 26
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 84.4,
  y1: 43.3,
  x2: 114.9,
  y2: 27
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 84.8,
  y1: 44.3,
  x2: 115.4,
  y2: 28
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 75.9,
  y1: 24.7,
  x2: 84.8,
  y2: 44.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 104.4,
  y1: 6.9,
  x2: 75.9,
  y2: 24.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 115.4,
  y1: 28,
  x2: 104.4,
  y2: 6.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 76.9,
  y1: 24.1,
  x2: 86.1,
  y2: 43.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 78.3,
  y1: 23.2,
  x2: 87.3,
  y2: 43
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 79.3,
  y1: 22.6,
  x2: 88.6,
  y2: 42.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 80.5,
  y1: 21.8,
  x2: 89.9,
  y2: 41.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 81.8,
  y1: 21,
  x2: 91,
  y2: 40.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 84.3,
  y1: 19.5,
  x2: 93.8,
  y2: 39.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 85.5,
  y1: 18.7,
  x2: 95.1,
  y2: 38.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 86.7,
  y1: 18,
  x2: 96.6,
  y2: 38
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 88.1,
  y1: 17.1,
  x2: 97.9,
  y2: 37.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 89.3,
  y1: 16.3,
  x2: 99.2,
  y2: 36.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 90.6,
  y1: 15.5,
  x2: 100.8,
  y2: 35.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 92,
  y1: 14.6,
  x2: 102.2,
  y2: 35
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 93.3,
  y1: 13.8,
  x2: 103.6,
  y2: 34.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 94.7,
  y1: 13,
  x2: 105,
  y2: 33.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 97.4,
  y1: 11.2,
  x2: 107.8,
  y2: 31.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 98.9,
  y1: 10.3,
  x2: 109.4,
  y2: 31.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 100.1,
  y1: 9.5,
  x2: 110.9,
  y2: 30.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 101.7,
  y1: 8.6,
  x2: 112.3,
  y2: 29.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 103.2,
  y1: 7.6,
  x2: 113.7,
  y2: 28.6
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 116.1,
  y1: 32.5,
  x2: 127.8,
  y2: 55.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 114.5,
  y1: 33.3,
  x2: 126.1,
  y2: 55.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 113,
  y1: 34.1,
  x2: 124.4,
  y2: 56.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 111.5,
  y1: 34.9,
  x2: 122.8,
  y2: 57.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 110,
  y1: 35.7,
  x2: 121.4,
  y2: 58
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 108.5,
  y1: 36.5,
  x2: 119.5,
  y2: 58.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 107.1,
  y1: 37.5,
  x2: 118,
  y2: 59.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 105.6,
  y1: 38,
  x2: 116.6,
  y2: 60
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 104,
  y1: 38.9,
  x2: 114.8,
  y2: 60.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 102.7,
  y1: 39.6,
  x2: 113.3,
  y2: 61.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 101.2,
  y1: 40.3,
  x2: 111.8,
  y2: 62
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 99.8,
  y1: 41.1,
  x2: 110.3,
  y2: 62.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 98.4,
  y1: 41.8,
  x2: 108.7,
  y2: 63.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 97.1,
  y1: 42.5,
  x2: 107.3,
  y2: 63.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 95.7,
  y1: 43.3,
  x2: 105.9,
  y2: 64.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 94.6,
  y1: 43.8,
  x2: 104.5,
  y2: 65.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 93.1,
  y1: 44.6,
  x2: 102.9,
  y2: 65.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 91.7,
  y1: 45.4,
  x2: 101.6,
  y2: 66.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 90.3,
  y1: 46.1,
  x2: 100,
  y2: 66.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 88.9,
  y1: 46.8,
  x2: 98.9,
  y2: 67.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 87.8,
  y1: 47.4,
  x2: 97.3,
  y2: 68.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 117.9,
  y1: 32.8,
  x2: 86.9,
  y2: 48.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 118.4,
  y1: 33.8,
  x2: 87.3,
  y2: 49.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 118.7,
  y1: 34.7,
  x2: 87.7,
  y2: 50.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 119.4,
  y1: 35.5,
  x2: 88.1,
  y2: 51.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 119.8,
  y1: 36.6,
  x2: 88.5,
  y2: 52.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 120.3,
  y1: 37.4,
  x2: 88.8,
  y2: 52.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 120.8,
  y1: 38.4,
  x2: 89.3,
  y2: 53.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 121.3,
  y1: 39.3,
  x2: 89.6,
  y2: 54.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 121.8,
  y1: 40.4,
  x2: 90.1,
  y2: 55.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 122.3,
  y1: 41.2,
  x2: 90.5,
  y2: 56.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 122.7,
  y1: 42.2,
  x2: 90.8,
  y2: 57.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 123.4,
  y1: 43.3,
  x2: 91.3,
  y2: 58.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 123.8,
  y1: 44.1,
  x2: 91.7,
  y2: 59.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 124.3,
  y1: 45,
  x2: 92,
  y2: 59.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 124.8,
  y1: 46.1,
  x2: 92.5,
  y2: 60.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 125.2,
  y1: 46.9,
  x2: 93,
  y2: 61.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 125.8,
  y1: 47.9,
  x2: 93.3,
  y2: 62.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 126.3,
  y1: 48.9,
  x2: 93.7,
  y2: 63.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 126.8,
  y1: 49.8,
  x2: 94.1,
  y2: 64.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 127.3,
  y1: 50.8,
  x2: 94.4,
  y2: 65.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 127.6,
  y1: 51.8,
  x2: 94.9,
  y2: 66
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 128.3,
  y1: 52.7,
  x2: 95.4,
  y2: 66.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 128.8,
  y1: 53.8,
  x2: 95.7,
  y2: 67.8
})), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 129.2,
  y1: 54.6,
  x2: 95.9,
  y2: 68.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 86.5,
  y1: 47.9,
  x2: 95.9,
  y2: 68.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 117.4,
  y1: 31.8,
  x2: 86.5,
  y2: 47.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 129.2,
  y1: 54.6,
  x2: 117.4,
  y2: 31.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 55.2,
  y1: 48.9,
  x2: 78.9,
  y2: 35
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 83.4,
  y1: 44.8,
  x2: 74.5,
  y2: 25.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 51.4,
  y1: 40,
  x2: 74.5,
  y2: 25.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 59,
  y1: 58,
  x2: 51.6,
  y2: 40.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 83.4,
  y1: 44.8,
  x2: 59,
  y2: 58
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 52.3,
  y1: 39.5,
  x2: 59.9,
  y2: 57.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 53.3,
  y1: 38.9,
  x2: 60.9,
  y2: 56.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 54.3,
  y1: 38.2,
  x2: 61.9,
  y2: 56.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 55.3,
  y1: 37.6,
  x2: 62.9,
  y2: 55.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 57.2,
  y1: 36.4,
  x2: 65.1,
  y2: 54.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 58.2,
  y1: 35.7,
  x2: 66.1,
  y2: 54
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 59.4,
  y1: 35,
  x2: 67.3,
  y2: 53.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 60.3,
  y1: 34.5,
  x2: 68.4,
  y2: 52.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 61.4,
  y1: 33.8,
  x2: 69.5,
  y2: 52.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 62.4,
  y1: 33.1,
  x2: 70.5,
  y2: 51.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 63.5,
  y1: 32.4,
  x2: 71.6,
  y2: 51
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 64.5,
  y1: 31.8,
  x2: 72.8,
  y2: 50.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 65.5,
  y1: 31.2,
  x2: 73.9,
  y2: 50
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 66.6,
  y1: 30.5,
  x2: 75.1,
  y2: 49.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 68.9,
  y1: 29,
  x2: 77.4,
  y2: 47.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 70.1,
  y1: 28.3,
  x2: 78.7,
  y2: 47.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 71.2,
  y1: 27.6,
  x2: 79.9,
  y2: 46.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 72.3,
  y1: 26.9,
  x2: 81.1,
  y2: 46.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 73.4,
  y1: 26.2,
  x2: 82.4,
  y2: 45.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 51.9,
  y1: 40.7,
  x2: 74.8,
  y2: 26.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 52.1,
  y1: 41.4,
  x2: 75.2,
  y2: 27.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 52.4,
  y1: 42,
  x2: 75.4,
  y2: 28
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 52.7,
  y1: 42.8,
  x2: 75.9,
  y2: 28.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 53,
  y1: 43.5,
  x2: 76.3,
  y2: 29.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 53.3,
  y1: 44.3,
  x2: 76.6,
  y2: 30.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 53.7,
  y1: 45.1,
  x2: 77,
  y2: 31.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 54,
  y1: 45.8,
  x2: 77.4,
  y2: 31.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 54.3,
  y1: 46.7,
  x2: 77.7,
  y2: 32.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 54.6,
  y1: 47.4,
  x2: 78.2,
  y2: 33.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 54.9,
  y1: 48.1,
  x2: 78.5,
  y2: 34.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 55.8,
  y1: 50.3,
  x2: 79.6,
  y2: 36.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 56.2,
  y1: 51.1,
  x2: 80,
  y2: 37.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 56.5,
  y1: 51.9,
  x2: 80.4,
  y2: 38.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 56.8,
  y1: 52.6,
  x2: 80.8,
  y2: 39.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 57.1,
  y1: 53.4,
  x2: 81.2,
  y2: 40
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 57.4,
  y1: 54.2,
  x2: 81.5,
  y2: 40.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 57.7,
  y1: 55,
  x2: 81.9,
  y2: 41.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 58.1,
  y1: 55.8,
  x2: 82.4,
  y2: 42.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 58.4,
  y1: 56.5,
  x2: 82.7,
  y2: 43.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 58.6,
  y1: 57.2,
  x2: 83.1,
  y2: 44.1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 85.1,
  y1: 48.5,
  x2: 94.6,
  y2: 69.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 83.9,
  y1: 49.1,
  x2: 93.4,
  y2: 69.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 85.1,
  y1: 48.5,
  x2: 60.3,
  y2: 61.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 68.3,
  y1: 80.6,
  x2: 60.3,
  y2: 61.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 94.6,
  y1: 69.3,
  x2: 68.3,
  y2: 80.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 82.7,
  y1: 49.8,
  x2: 92,
  y2: 70.4
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 81.4,
  y1: 50.4,
  x2: 90.8,
  y2: 70.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 80.2,
  y1: 51.1,
  x2: 89.5,
  y2: 71.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 79,
  y1: 51.7,
  x2: 88.2,
  y2: 72
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 76.7,
  y1: 52.9,
  x2: 85.7,
  y2: 73.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 75.4,
  y1: 53.6,
  x2: 84.5,
  y2: 73.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 74.3,
  y1: 54.2,
  x2: 83.1,
  y2: 74.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 73.2,
  y1: 54.8,
  x2: 81.9,
  y2: 74.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 72.1,
  y1: 55.4,
  x2: 80.8,
  y2: 75.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 70.9,
  y1: 56,
  x2: 79.6,
  y2: 75.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 69.9,
  y1: 56.5,
  x2: 78.3,
  y2: 76.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 68.8,
  y1: 57.2,
  x2: 77.1,
  y2: 76.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 67.7,
  y1: 57.7,
  x2: 76,
  y2: 77.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 66.6,
  y1: 58.3,
  x2: 74.9,
  y2: 77.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 64.5,
  y1: 59.4,
  x2: 72.6,
  y2: 78.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 63.4,
  y1: 59.9,
  x2: 71.4,
  y2: 79
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 62.4,
  y1: 60.5,
  x2: 70.2,
  y2: 79.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 61.4,
  y1: 61,
  x2: 69.2,
  y2: 80.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 68,
  y1: 79.8,
  x2: 94.2,
  y2: 68.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 93.8,
  y1: 67.5,
  x2: 67.7,
  y2: 79
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 67.3,
  y1: 78.2,
  x2: 93.4,
  y2: 66.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 93,
  y1: 65.8,
  x2: 67,
  y2: 77.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 66.6,
  y1: 76.5,
  x2: 92.6,
  y2: 64.9
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 92.2,
  y1: 64,
  x2: 66.3,
  y2: 75.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 65.9,
  y1: 74.9,
  x2: 91.8,
  y2: 63.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 91.2,
  y1: 62.3,
  x2: 65.5,
  y2: 74
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 90.9,
  y1: 61.3,
  x2: 65.3,
  y2: 73
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 90.5,
  y1: 60.4,
  x2: 64.9,
  y2: 72.3
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 64.5,
  y1: 71.6,
  x2: 90.2,
  y2: 59.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 63.8,
  y1: 70,
  x2: 89.3,
  y2: 57.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 88.9,
  y1: 57.1,
  x2: 63.5,
  y2: 69.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 63.2,
  y1: 68.5,
  x2: 88.6,
  y2: 56.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 88.2,
  y1: 55.4,
  x2: 63.1,
  y2: 67.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 62.5,
  y1: 66.9,
  x2: 87.7,
  y2: 54.5
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 87.4,
  y1: 53.5,
  x2: 62.2,
  y2: 66
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 61.8,
  y1: 65.3,
  x2: 87,
  y2: 52.8
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 86.7,
  y1: 51.9,
  x2: 61.5,
  y2: 64.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 61.2,
  y1: 63.8,
  x2: 86.1,
  y2: 51.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 85.8,
  y1: 50.1,
  x2: 60.9,
  y2: 63
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 60.6,
  y1: 62.2,
  x2: 85.4,
  y2: 49.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23,90.6c7.1-3.7,10.7-5.6,17.8-9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M25.3,80.8c1.8,6,2.7,9,4.5,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M33.1,76.2c2,6.2,3,9.3,5.1,15.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.2,74.4c6.7-4.3,10-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20,64.3c1.7,5.6,2.6,8.4,4.3,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M27.4,59.1c1.9,5.8,2.9,8.7,4.8,14.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.2,67.6c6.5-4.6,9.7-6.9,16.2-11.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.4,68.1c6.5-4.5,9.8-6.8,16.3-11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.5,68.8c6.5-4.5,9.7-6.7,16.2-11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.7,69.3c6.5-4.5,9.7-6.7,16.2-11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.8,69.8c6.5-4.4,9.8-6.7,16.3-11.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17,70.4c6.5-4.4,9.8-6.6,16.3-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.2,71c6.6-4.4,9.8-6.6,16.4-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.3,71.5c6.6-4.4,9.9-6.6,16.5-11"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M34,61.1c-6.6,4.4-9.9,6.5-16.5,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.7,72.6c6.6-4.3,9.9-6.5,16.5-10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.8,73.2c6.6-4.3,9.9-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18,73.8c6.7-4.3,10-6.4,16.6-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.4,75c6.7-4.3,10-6.4,16.7-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.5,75.5c6.7-4.2,10-6.4,16.7-10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.7,76.1c6.7-4.3,10.1-6.4,16.8-10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.8,76.6c6.7-4.2,10.1-6.3,16.9-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19,77.2c6.7-4.2,10.1-6.3,16.9-10.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.2,77.8c6.8-4.2,10.2-6.2,16.9-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.4,78.4c6.8-4.1,10.2-6.2,17-10.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.6,78.9c6.8-4.1,10.2-6.2,16.9-10.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.7,79.6c6.8-4.2,10.2-6.2,17-10.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.9,80.1C26.7,76,30.1,74,37,69.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20.1,80.8c6.9-4.1,10.3-6.1,17.1-10.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16,67.1c1.6,5.5,2.4,8.2,4,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M32.1,55.8c-6.4,4.5-9.7,6.8-16.1,11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M37.2,70.6c-2-5.9-3-8.9-5.1-14.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.6,66.7c1.7,5.5,2.5,8.2,4.2,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.4,66.1c1.6,5.5,2.4,8.3,4.1,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.9,65.7c1.7,5.5,2.5,8.3,4.2,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.7,65.2c1.7,5.5,2.5,8.3,4.2,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.4,64.7c1.7,5.5,2.5,8.3,4.2,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20.8,63.7c1.7,5.6,2.6,8.4,4.3,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M21.5,63.2c1.7,5.6,2.6,8.4,4.3,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.1,62.8c1.8,5.6,2.7,8.4,4.5,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.9,62.2c1.8,5.7,2.7,8.5,4.5,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23.6,61.7c1.8,5.7,2.7,8.5,4.5,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M24.4,61.2c1.8,5.7,2.8,8.5,4.6,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M25.1,60.7c1.9,5.7,2.8,8.6,4.7,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M25.9,60.2c1.9,5.7,2.8,8.6,4.7,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M26.6,59.6c1.9,5.8,2.8,8.6,4.7,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M28.2,58.5c1.9,5.8,2.8,8.7,4.7,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M29,58c1.9,5.8,2.9,8.8,4.8,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M29.7,57.5c2,5.8,3,8.8,5,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M30.6,56.8c1.9,5.9,2.9,8.8,4.9,14.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M31.4,56.2c1.9,5.9,2.9,8.8,4.8,14.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M37.3,73.7c2.2,6.4,3.2,9.5,5.4,15.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M36.5,74.2c2.1,6.3,3.2,9.5,5.3,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M35.7,74.7c2.1,6.3,3.1,9.5,5.2,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M34.8,75.2c2.1,6.3,3.1,9.4,5.2,15.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M34,75.7c2.1,6.2,3.1,9.3,5.2,15.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M33.1,76.2c2,6.2,3,9.3,5.1,15.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M32.3,76.8c2,6.1,3,9.2,5,15.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M31.5,77.2c2,6.2,3,9.2,5,15.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M30.6,77.7c2,6.1,3,9.2,4.9,15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M29.9,78.1c1.9,6.1,2.9,9.2,4.8,15.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M29,78.6c1.9,6.1,2.9,9.1,4.8,15.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M28.2,79.1c1.9,6.1,2.9,9.1,4.8,15.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M27.5,79.5c1.9,6,2.8,9.1,4.6,15.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M26.7,79.9c1.8,6,2.8,9,4.6,15"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M25.9,80.4c1.8,6,2.8,9,4.6,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M25.3,80.8c1.8,6,2.7,9,4.5,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M24.5,81.3c1.8,5.9,2.6,8.9,4.4,14.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23.7,81.7c1.8,5.9,2.7,8.8,4.5,14.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.9,82.2c1.8,5.8,2.6,8.7,4.4,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.2,82.6c1.8,5.8,2.7,8.7,4.5,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M21.5,83c1.7,5.8,2.6,8.7,4.3,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M38.3,73.9c-6.9,3.9-10.4,5.9-17.3,9.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M38.6,74.7c-7,3.9-10.4,5.8-17.4,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M38.7,75.3c-6.9,3.9-10.4,5.8-17.4,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M39,75.8c-7,3.9-10.5,5.8-17.5,9.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M39.2,76.6c-7,3.9-10.5,5.8-17.5,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M39.4,77.2c-7,3.8-10.5,5.7-17.6,9.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M39.7,77.9c-7,3.8-10.6,5.7-17.6,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M39.9,78.5c-7.1,3.8-10.6,5.6-17.7,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M40.1,79.3C33,83,29.5,84.9,22.4,88.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M40.3,79.9c-7.1,3.8-10.6,5.6-17.7,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M40.5,80.6c-7.1,3.7-10.7,5.6-17.8,9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M40.8,81.3C33.7,85,30.1,86.9,23,90.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M41,81.9c-7.1,3.7-10.7,5.5-17.9,9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M41.3,82.5c-7.2,3.6-10.8,5.5-17.9,9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M41.5,83.3c-7.2,3.6-10.8,5.4-18,9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M41.7,83.9c-7.2,3.6-10.8,5.4-18,9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M42,84.6c-7.2,3.6-10.9,5.4-18.1,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M42.2,85.2c-7.3,3.6-10.9,5.3-18.1,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M42.4,85.9c-7.3,3.6-10.9,5.3-18.2,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M42.6,86.6c-7.3,3.5-11,5.2-18.3,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M42.8,87.3c-7.3,3.5-10.9,5.2-18.2,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M43.1,87.9c-7.3,3.5-11,5.2-18.3,8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M43.4,88.7c-7.4,3.4-11.1,5.1-18.4,8.5"
})), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M43.5,89.2c-7.4,3.5-11.1,5.2-18.5,8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20.8,83.3c1.7,5.8,2.5,8.7,4.2,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M38.1,73.3c-6.9,4-10.4,6-17.3,10"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M43.5,89.2c-2.2-6.4-3.3-9.6-5.5-15.9"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.9,74.9C6.3,80,7,82.5,8.4,87.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M11.5,70.3c1.5,5.3,2.3,7.9,3.8,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.1,83.4c5.3-3.4,8-5.2,13.3-8.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.9,82.9c5.3-3.5,8-5.2,13.3-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.3,81.1c-1.6-5.4-2.4-8.1-4-13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.2,76.8c5.2-3.7,7.8-5.5,13-9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5.6,89.3c-1.3-5-1.9-7.5-3.2-12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.3,81.1C13.8,84.4,11,86,5.6,89.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.7,76.4c1.4,5,2,7.5,3.4,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.3,76c1.3,5,2,7.6,3.4,12.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.8,75.6c1.3,5,2,7.5,3.4,12.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.4,75.2c1.4,5.1,2,7.6,3.4,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5.5,74.5c1.4,5.1,2.1,7.6,3.5,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.1,74.1c1.4,5.1,2.1,7.6,3.5,12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.7,73.6c1.4,5.2,2.1,7.7,3.5,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.2,73.2c1.4,5.2,2.2,7.7,3.6,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.9,72.8c1.4,5.2,2.2,7.7,3.6,12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M8.4,72.4c1.5,5.2,2.2,7.8,3.6,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9,72c1.5,5.2,2.2,7.8,3.6,13"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.6,71.6c1.5,5.2,2.2,7.8,3.7,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M10.2,71.2c1.5,5.3,2.2,7.9,3.7,13.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M10.8,70.7c1.5,5.3,2.3,7.9,3.8,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M12.1,69.8c1.5,5.3,2.3,7.9,3.8,13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M12.8,69.3c1.5,5.3,2.3,8,3.8,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M13.4,68.9c1.6,5.3,2.4,8,3.9,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M14,68.5c1.6,5.4,2.4,8,4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M14.7,68c1.6,5.4,2.4,8.1,4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.4,77.2c5.2-3.7,7.8-5.5,12.9-9.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.6,77.7c5.2-3.6,7.8-5.4,13-9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.7,78.2c5.2-3.6,7.8-5.3,13-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M2.8,78.7c5.2-3.6,7.8-5.4,13.1-9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3,79.2c5.2-3.5,7.9-5.3,13.1-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.1,79.8c5.2-3.6,7.9-5.3,13.1-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.2,80.3c5.3-3.5,7.9-5.3,13.2-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.4,80.8c5.3-3.5,7.9-5.3,13.2-8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.5,81.4c5.3-3.6,7.9-5.3,13.2-8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.6,81.9c5.3-3.5,8-5.3,13.3-8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M3.8,82.4c5.3-3.5,8-5.2,13.3-8.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.2,84c5.4-3.4,8-5.1,13.4-8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.3,84.5c5.4-3.4,8-5.1,13.4-8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.5,85.1c5.4-3.4,8-5.1,13.4-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.6,85.6c5.4-3.4,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.7,86.1c5.4-3.3,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M4.9,86.7c5.4-3.3,8.1-5,13.5-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5,87.2c5.4-3.4,8.1-5,13.6-8.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5.2,87.8c5.4-3.3,8.2-5,13.6-8.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5.3,88.3c5.5-3.3,8.2-5,13.7-8.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M5.4,88.7c5.5-3.3,8.2-4.9,13.7-8.2"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16,86c1.6,5.7,2.4,8.5,4,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.1,90.1c1.4,5.4,2.1,8.1,3.6,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.1,90.8c-5.7,3-8.6,4.5-14.3,7.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20,83.7c1.7,5.8,2.6,8.7,4.3,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M19.3,84.1c1.7,5.8,2.6,8.6,4.3,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20,83.7c-5.6,3.3-8.3,4.9-13.9,8.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.7,105.1c-1.4-5.3-2.1-8-3.5-13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M24.3,98.2c-5.9,2.8-8.8,4.1-14.6,6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18.7,84.4c1.7,5.8,2.5,8.6,4.2,14.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M18,84.9c1.7,5.7,2.5,8.6,4.2,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M17.3,85.3c1.7,5.7,2.5,8.5,4.2,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M16.6,85.7c1.6,5.7,2.5,8.5,4.1,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M15.3,86.4c1.6,5.6,2.4,8.5,4,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M14.6,86.8c1.6,5.6,2.4,8.4,4.1,14"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M14,87.2c1.6,5.6,2.4,8.4,4,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M13.4,87.6c1.6,5.5,2.3,8.3,3.9,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M12.7,87.9c1.6,5.5,2.3,8.3,3.9,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M12.1,88.3c1.6,5.5,2.3,8.2,3.9,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M11.5,88.7c1.5,5.5,2.3,8.3,3.8,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M10.9,89.1c1.5,5.4,2.2,8.2,3.7,13.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M10.3,89.4c1.5,5.5,2.2,8.2,3.7,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.7,89.7c1.5,5.4,2.2,8.1,3.7,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M8.5,90.5c1.4,5.4,2.1,8.1,3.6,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.9,90.8c1.4,5.3,2.1,8,3.5,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.3,91.1c1.4,5.3,2.1,8,3.5,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.7,91.4c1.4,5.3,2.1,8,3.4,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.5,104.5c5.8-2.8,8.8-4.1,14.6-6.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23.9,96.9c-5.8,2.8-8.7,4.2-14.5,7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M9.2,103.4c5.8-2.8,8.7-4.2,14.5-7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23.6,95.8c-5.8,2.8-8.7,4.2-14.5,7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M8.9,102.2c5.8-2.8,8.7-4.3,14.5-7.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M23.2,94.5c-5.8,2.9-8.7,4.3-14.4,7.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M8.6,101.1c5.8-2.9,8.6-4.3,14.4-7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.8,93.3c-5.7,2.9-8.6,4.3-14.3,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.6,92.6c-5.7,2.9-8.6,4.3-14.3,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M22.5,92c-5.7,2.9-8.6,4.4-14.3,7.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M8,98.8c5.7-2.9,8.6-4.4,14.3-7.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.7,97.7c5.7-3,8.5-4.5,14.2-7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M21.7,89.6c-5.7,3-8.5,4.5-14.1,7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.4,96.6c5.7-3,8.5-4.5,14.2-7.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M21.4,88.5C15.8,91.5,13,93,7.4,96.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M7.1,95.5c5.6-3.1,8.4-4.6,14.1-7.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M21,87.2c-5.6,3.1-8.5,4.7-14.1,7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.8,94.4c5.6-3.1,8.4-4.7,14.1-7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20.7,86c-5.6,3.1-8.4,4.7-14,7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.5,93.3c5.6-3.1,8.4-4.7,13.9-7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M20.4,84.8c-5.6,3.2-8.4,4.8-14,8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst29",
  d: "M6.2,92.3c5.6-3.2,8.4-4.8,13.9-8.1"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 91.3,
  y1: 58.3,
  x2: 123.3,
  y2: 43.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 94.6,
  y1: 43.8,
  x2: 104.5,
  y2: 65.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 108.5,
  y1: 36.5,
  x2: 119.5,
  y2: 58.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 80.7,
  y1: 35.1,
  x2: 110.3,
  y2: 18.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 82.9,
  y1: 20.3,
  x2: 92.5,
  y2: 40.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 96,
  y1: 12.1,
  x2: 106.4,
  y2: 32.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 56.2,
  y1: 37,
  x2: 64,
  y2: 55.2
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 67.8,
  y1: 29.8,
  x2: 76.2,
  y2: 48.7
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 55.6,
  y1: 49.5,
  x2: 79.2,
  y2: 35.8
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 77.9,
  y1: 52.3,
  x2: 86.9,
  y2: 72.6
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 65.5,
  y1: 58.8,
  x2: 73.6,
  y2: 78.1
}), /*#__PURE__*/React.createElement("line", {
  className: "webst29",
  x1: 89.7,
  y1: 58.7,
  x2: 64.2,
  y2: 70.8
})))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "webst30",
  points: "26.3,68.9 23.9,74.2 40.4,78.2 42.2,74.6 "
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M23.6,74.2c0,0,1.9-3.2,2.7-5.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M40.4,78.2c0,0,1.2-2.1,1.9-3.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "webst32",
  points: "26,69.6 42.2,74.7 42,75 25.7,70.3 25.4,70.9 41.8,75.5 41.6,75.9 25.1,71.5 24.8,72 41.3,76.5  41.1,76.9 24.5,72.5 24.2,73.2 40.8,77.4 40.5,77.8 23.9,73.7  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M24.4,74.3c0,0,1.9-3.1,2.8-5.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M25.3,74.6c0,0,1.9-3.1,2.7-5.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M26,74.7c0,0,1.9-2.9,2.7-5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M26.8,74.9c0,0,1.7-2.9,2.6-5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M27.7,75.1c0,0,1.7-2.8,2.5-4.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M28.4,75.3c0,0,1.7-2.9,2.4-4.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M29.1,75.5c0,0,1.8-2.8,2.6-4.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M29.9,75.7c0,0,1.8-2.8,2.5-4.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M30.8,75.9c0,0,1.7-2.6,2.5-4.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M31.5,76c0,0,1.6-2.6,2.3-4.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M32.3,76.2c0,0,1.5-2.5,2.2-4.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M33,76.4c0,0,1.6-2.6,2.3-4.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M33.7,76.6c0,0,1.6-2.5,2.3-4.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M34.4,76.7c0,0,1.6-2.4,2.3-4.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M35.1,76.9c0,0,1.6-2.4,2.3-4.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M35.8,77.1c0,0,1.4-2.3,2.1-4.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M36.5,77.2c0,0,1.4-2.3,2.1-4.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M37.1,77.4c0,0,1.4-2.3,2-4"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M37.8,77.5c0,0,1.5-2.3,2.1-3.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M38.5,77.7c0,0,1.4-2.2,2.1-3.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M39.1,77.9c0,0,1.4-2.1,2-3.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst31",
  d: "M39.7,78c0,0,1.3-2.1,1.9-3.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "webst32",
  d: "M40.4,78.2l-16.8-4.1c0.3-0.1,2.6-5.3,2.6-5.3l16,5.6"
})))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "webst33",
  d: "M47,77.5l6.4,1.6l2.4-1.1c0,0,0.8-0.7,0-1.7l-6.3-2.2l-3,1.5C46.5,75.6,46,76.9,47,77.5z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "webst34",
  d: "M46.4,75.6l3-1.5c0,0,1.7,0.9,0.7,2.2l-3,1.2C47.1,77.5,46.2,77.5,46.4,75.6z"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst35",
  points: "55.8,78 50.1,76.3 47.1,77.5 53.4,79.1 "
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "webst36",
  d: "M55.9,57.6l-2.2-0.6v0h0l-1.4-0.4c0,0.1,0.1,0.2,0.1,0.2l-1-0.1l0.1-0.2l-16.2-7l0,0c-0.6-0.7-1.2-1.1-1.2-1.1 l-2.4-0.9c0.1,0.2,0.1,0.5,0.2,0.7c-0.3-0.6-0.7-1.1-1.1-1.5c-1.6-1.3-3.8-1-3.8-1l-5.8,1.1l2.5,20.7c0.4-0.1,0.8-0.3,1.3-0.5 l0.8,0.3l19.7,6.8l0.1-0.3l0.4,0.1c-0.3,0.2-0.5,0.2-0.5,0.2l5.1,2.3l3.8-2.3l3.3-4l1.2-4.7C60.8,62.5,55.9,57.6,55.9,57.6z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "webst37",
  d: "M25.8,66.6c0-0.2,0-0.2,0-0.2s10.3-5.1,7-18.1c0,0-1.5-3.2-5.4-2.5L21.1,47l2.8,21L25.8,66.6z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDW_20_",
  gradientUnits: "userSpaceOnUse",
  x1: 28.715,
  y1: 68.2563,
  x2: 28.715,
  y2: 68.2563
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2699,
  style: {
    stopColor: "#C9E3F4",
    stopOpacity: 0.7301
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6157,
  style: {
    stopColor: "#8AC2E7",
    stopOpacity: 0.3843
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8687,
  style: {
    stopColor: "#62AEDF",
    stopOpacity: 0.1313
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "webst38",
  d: "M28.7,68.3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDW_21_",
  gradientUnits: "userSpaceOnUse",
  x1: 29.1986,
  y1: 60.3177,
  x2: 54.6266,
  y2: 60.3177
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2699,
  style: {
    stopColor: "#C9E3F4",
    stopOpacity: 0.7301
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6157,
  style: {
    stopColor: "#8AC2E7",
    stopOpacity: 0.3843
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8687,
  style: {
    stopColor: "#62AEDF",
    stopOpacity: 0.1313
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "webst39",
  d: "M34.8,64.9l17.5,6l-0.7-1.6l-15.8-5.5l1.8-4.9l16.6,6.1v-1.2l-16.6-7c0,0,0.5-5.8-0.9-6.4l-1.4-0.6l0.3,1.8 l1.2,0.3c0,0,4.8,12.2-2.7,15.8S30.8,67,30.8,67L34.8,64.9z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDW_22_",
  cx: 19.5325,
  cy: 55.8297,
  r: 10.6367,
  gradientTransform: "matrix(0.9472 0 0 0.9964 5.5451 -1.1789)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1137,
  style: {
    stopColor: "#F7FBFD",
    stopOpacity: 0.8863
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2856,
  style: {
    stopColor: "#E3F0F9",
    stopOpacity: 0.7144
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4944,
  style: {
    stopColor: "#C1DFF2",
    stopOpacity: 0.5056
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  style: {
    stopColor: "#91C6E9",
    stopOpacity: 0.268
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.991,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009000838
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  className: "webst40",
  cx: 23.2,
  cy: 54.3,
  rx: 9.5,
  ry: 11.2
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst41",
  points: "28.3,63.7 25.8,62.5 25.4,59.1 24.7,58.9 24.7,56.9 24.7,49.8 28.3,49.9 27.4,41.2 24.7,39.1  24.7,36.9 18.7,33.9 11.6,40.1 8.9,45.7 8.9,70.9 19.8,64.7 24.9,66 28.5,67.9 32.9,65 30.5,62.5 "
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst42",
  points: "19,66.1 19,34.2 24.7,36.9 25.8,66.6 "
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  className: "webst43",
  d: "M32.9,65L30.1,62l-1.7,1.8l0.1,4.1C28.5,67.9,31.1,67.6,32.9,65z"
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "webst41",
  points: "28.3,49.9 27.4,41.2 24.7,39.1 "
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst0",
  points: "18.5,34.9 12.3,40.3 9.6,45.9 9.6,69.1 18.3,67.2 "
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst44",
  points: "25.4,66.6 15.6,63.9 5.5,70.3 14.2,72.6 "
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "24,39.2 19.5,37.2 19.4,34.5 24,36.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "24.7,43.5 19.2,41.4 19.2,37.7 24.6,40  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "24.9,47.4 19.2,44.9 19.2,41.7 24.8,43.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "25.5,51.3 19,48.9 19,45.6 25.4,48  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "24.6,54 20.2,52.6 20.2,49.7 24.6,51.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "22.3,57.2 20.1,56.7 20.1,53.1 22.4,54  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "24.9,58.1 22.6,57.3 22.7,54 24.9,54.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "26.2,62.7 20,61 19.9,57.5 26.1,59.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "webst45",
  points: "25.5,65.9 22.3,64.9 22.2,62.1 25.3,63  "
}))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst46",
  points: "24.1,38.9 19.6,36.9 19.6,34.2 24.1,36.4 "
})), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "24.9,43.2 19.3,41 19.3,37.4 24.8,39.7 "
})), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "25.1,47 19.3,44.6 19.3,41.3 24.9,43.6 "
})), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "25.6,51 19,48.5 19,45.2 25.5,47.7 "
})), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "24.8,53.6 20.3,52.3 20.3,49.3 24.8,51 "
})), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "22.4,56.9 20.2,56.4 20.2,52.7 22.5,53.6 "
})), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst47",
  points: "25,57.8 22.7,57 22.8,53.7 25,54 "
})), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst46",
  points: "26.3,62.3 20.1,60.6 20,57.4 26.2,59.3 "
})), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst46",
  points: "25.6,65.8 22.4,64.8 22.3,62 25.4,62.7 "
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  className: "webst1",
  d: "M46.1,74.2l4.9-3.3c0,0,3.6-4.8,3.1-6.7c0,0,0.5-2.8-0.9-7.3l3.1,0.8v1l1.6,1.1c0,0,3.1,5.1,0,11l-6,4.5 L46.1,74.2z"
})), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst0",
  points: "54.6,72.6 50.8,70.9 47,74.2 50.8,75.8 "
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  className: "webst0",
  d: "M56.6,70.9L53,69.3c0,0,0.9-2.9,2.7-3.1c0,0-2-0.6,0.9-1.9l0.9-1.5l0.9-0.4C58.4,62.3,59.9,68.1,56.6,70.9z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  className: "webst0",
  d: "M53.7,57.3l2.2,1.6c0,0,4.4,4.6,1.7,3.7l-2.9-2.5L53.7,57.3z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  className: "webst48",
  d: "M56.1,69.3c0,0-0.6-2.1,1.3-2.7c0,0-1.2-1.5,0.2-1.9l0.5-2l-3-2.7c0,0-0.6-1.4-0.4-1.5l3.7,4.1 c0,0,0.4,4.9-1.1,7.2C57.1,69.9,56.3,70.3,56.1,69.3z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  className: "webst24",
  d: "M56.2,59.9l-1,0.5c0,0,0,2.4,1.5,2.6l1-0.5v-0.3l0.7-0.4c0,0,0.5-0.2,0.3-0.7l41.4-21.8c0,0,0.1-1-0.7-1.2 L58,59.9c0,0-0.2-0.4-0.5-0.3l-0.8,0.4L56.2,59.9z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDW_23_",
  cx: 13.9393,
  cy: 52.3471,
  r: 11.2975,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1137,
  style: {
    stopColor: "#F7FBFD",
    stopOpacity: 0.8863
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2856,
  style: {
    stopColor: "#E3F0F9",
    stopOpacity: 0.7144
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4944,
  style: {
    stopColor: "#C1DFF2",
    stopOpacity: 0.5056
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  style: {
    stopColor: "#91C6E9",
    stopOpacity: 0.268
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.991,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009000838
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
  className: "webst49",
  points: "17.8,36.8 12.4,41.7 10.1,46.8 10.1,67.8 17.6,66.2 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSatellite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Satellite.c16f3340.svg";
export { ForwardRef as ReactComponent };